import React, { useState } from "react";
import { bool } from "prop-types";
import { routerActions } from "connected-react-router";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
// import { actions as accountsActions } from "reducers/accounts";
import gaEventTracker, { events } from "util/gaEventTracker";
import { MobileButtons, ResponsiveHeader } from "pages/_components/header";
import Action from "pages/_components/Action";
import { isIOS } from "react-device-detect";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import DepositsSummary from "./components/DepositsSummary";
import { useCancelRenewalTransaction } from "./hooks/useCancelRenewalTransaction";

const SuccessCancelRenewalPage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, id, isBackoffice } = useCancelRenewalTransaction();
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "activities.deposit.cancelRenewal.send",
        id,
        "/deposits/cancelRenewal/successTransaction/",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    // const handleClick = () => {
    //     dispatch(accountsActions.toggleOptions());
    // };

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.pf_cancelar_renovacion_auto_descargar());
        handlePrint();
    };

    // const renderMenuOption = () => (
    //     <>
    //         {isDesktop ? (
    //             <div className="toolbar-item download" key="exportList">
    //                 <Button
    //                     className="btn btn-outline"
    //                     image="images/figma/icon/download.svg"
    //                     label="global.download"
    //                     onClick={handleDownload}
    //                     block={false}
    //                 />
    //             </div>
    //         ) : (
    //             <div className="toolbar-item commands-mobile">
    //                 <Button
    //                     className="toolbar-btn view-options"
    //                     onClick={handleClick}
    //                     image="images/figma/icon/menu-mobile.svg"
    //                     label="view more options"
    //                     block={false}
    //                     bsStyle="link"
    //                 />
    //                 <Button
    //                     className="btn btn-outline"
    //                     image="images/figma/icon/share.svg"
    //                     label="global.share"
    //                     onClick={() => {
    //                         handleShareMobile();
    //                     }}
    //                 />
    //             </div>
    //         )}
    //     </>
    // );

    return (
        <>
            <Notification scopeToShow="/deposits/cancelRenewal/successTransaction/" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="activities.deposit.cancelRenewal.send"
                    metaTitle="activities.deposit.cancelRenewal.send">
                    <MobileButtons
                        image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                        <Action labelKey="global.download" handleClick={() => handleDownload()} />
                        <Action labelKey="global.share" handleClick={() => handleShareMobile()} />
                    </MobileButtons>
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction} ref={mobileRef}>
                            <TransactionHeader title="activities.deposit.cancelRenewal.send" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <DepositsSummary
                                        isTicket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                        {!isBackoffice && (
                            <Row className="form-actions no-print">
                                <Col xs={12} md={4} mdOffset={2}>
                                    <CustomButton
                                        func={() => dispatch(routerActions.push("/desktop"))}
                                        text="forms.transaction.ticket.actions.backToHome"
                                        textType="I18N"
                                        className="btn btn-primary"
                                    />
                                </Col>
                                <Col xs={12} md={4}>
                                    <Button
                                        bsStyle="outline"
                                        onClick={handleDownload}
                                        label="global.download"
                                        image="images/download.svg"
                                    />
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>
            </MainContainer>
            {!isDesktop && (
                <Options>
                    <AccountAction isDesktop={isDesktop} labelKey="global.download" handleClick={handleDownload} />
                </Options>
            )}
        </>
    );
};

SuccessCancelRenewalPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default SuccessCancelRenewalPage;
